module.exports = __webpack_public_path__ + "static/media/headset.bdca501e.svg";